import { FC, memo } from 'react';
import { twMerge } from 'tailwind-merge';
import { titleStyles } from './alert.styles';
import { AlertType } from './types';

type AlertTitleProps = {
  type: AlertType;
  text: string;
};

const AlertTitleComp: FC<AlertTitleProps> = ({ text, type }) => {
  return <h3 className={twMerge('text-sm font-medium text-secondary-700', titleStyles({ type }))}>{text}</h3>;
};

export const AlertTitle = memo(AlertTitleComp);
